module.exports = __webpack_public_path__ + "img/bibliografruit@2x-100.09ea8d5c.jpg";